class ZerokitFaq {
    constructor(root) {
        this.root = root;

        this.items = Array.from(
            root.querySelectorAll(
                '[data-zk-faq-item]'
            )
        );

        if (!this.items.length) {
            return;
        }

        this.bindEvents();
    }


    /* ==========================================================================
       Events
       ========================================================================== */

    bindEvents() {
        this.items.forEach((item) => {
            const trigger =
                item.querySelector(
                    '[data-zk-faq-trigger]'
                );

            const panel =
                item.querySelector(
                    '[data-zk-faq-panel]'
                );

            if (!trigger || !panel) {
                return;
            }

            trigger.addEventListener(
                'click',
                () => {
                    this.toggleItem(
                        item,
                        trigger,
                        panel
                    );
                }
            );
        });
    }


    /* ==========================================================================
       Accordion
       ========================================================================== */

    toggleItem(
        item,
        trigger,
        panel
    ) {
        const expanded =
            trigger.getAttribute(
                'aria-expanded'
            ) === 'true';

        if (!expanded) {
            this.closeAll(item);
        }

        trigger.setAttribute(
            'aria-expanded',
            expanded
                ? 'false'
                : 'true'
        );

        panel.classList.toggle(
            'is-collapsed',
            expanded
        );
    }


    closeAll(exceptItem = null) {
        this.items.forEach((item) => {
            if (item === exceptItem) {
                return;
            }

            const trigger =
                item.querySelector(
                    '[data-zk-faq-trigger]'
                );

            const panel =
                item.querySelector(
                    '[data-zk-faq-panel]'
                );

            if (!trigger || !panel) {
                return;
            }

            trigger.setAttribute(
                'aria-expanded',
                'false'
            );

            panel.classList.add(
                'is-collapsed'
            );
        });
    }
}


/* ==========================================================================
   Initialization
   ========================================================================== */

const zerokitFaqInstances =
    new WeakMap();


function initZerokitFaq(
    scope = document
) {
    const sections =
        scope.matches?.(
            '[data-zk-faq]'
        )
            ? [scope]
            : Array.from(
                scope.querySelectorAll?.(
                    '[data-zk-faq]'
                ) || []
            );

    sections.forEach((section) => {
        if (
            zerokitFaqInstances.has(
                section
            )
        ) {
            return;
        }

        zerokitFaqInstances.set(
            section,
            new ZerokitFaq(section)
        );
    });
}


if (
    document.readyState === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        () => {
            initZerokitFaq();
        }
    );
} else {
    initZerokitFaq();
}


/* ==========================================================================
   Shopify Theme Editor
   ========================================================================== */

document.addEventListener(
    'shopify:section:load',
    (event) => {
        initZerokitFaq(
            event.target
        );
    }
);


document.addEventListener(
    'shopify:block:select',
    (event) => {
        const item =
            event.target.closest?.(
                '[data-zk-faq-item]'
            );

        if (!item) {
            return;
        }

        const section =
            item.closest(
                '[data-zk-faq]'
            );

        if (!section) {
            return;
        }

        const instance =
            zerokitFaqInstances.get(
                section
            );

        if (!instance) {
            return;
        }

        const trigger =
            item.querySelector(
                '[data-zk-faq-trigger]'
            );

        const panel =
            item.querySelector(
                '[data-zk-faq-panel]'
            );

        if (!trigger || !panel) {
            return;
        }

        instance.closeAll(item);

        trigger.setAttribute(
            'aria-expanded',
            'true'
        );

        panel.classList.remove(
            'is-collapsed'
        );
    }
);